import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=6ab687f4&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab687f4')) {
      api.createRecord('6ab687f4', component.options)
    } else {
      api.reload('6ab687f4', component.options)
    }
    module.hot.accept("./Access.vue?vue&type=template&id=6ab687f4&", function () {
      api.rerender('6ab687f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Access.vue"
export default component.exports